module.exports = __webpack_public_path__ + "img/3.375e7d20.jpg";